



































































import { Prop, Component, Vue } from 'vue-property-decorator'
import Draggable from 'vuedraggable'

@Component({
  components: {
    Draggable
  },
  filters: {
    thumbnail: (value: string) => {
      if (!value) return value
      return value.indexOf('.pdf') !== -1 ? '/images/document.jpg' : value
    }
  }
})
export default class Images extends Vue {
  @Prop({ default: false })
  images!: string[]

  @Prop({ default: false })
  isEditable!: Boolean

  private transparent: string = 'rgba(200, 200, 200, 0)'
  private orderedImages: string[] = this.images

  onMove () {
    console.log('on-move', this.orderedImages)
    this.$emit('on-move', this.orderedImages)
  }
}
